"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BORDER_WIDTHS = void 0;
var BORDER_WIDTHS = Object.freeze({
  NONE: 'none',
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl'
});
exports.BORDER_WIDTHS = BORDER_WIDTHS;